import {createContext} from "react";

export interface VaultPageContextInterface {
  setShowCreateCredentialModal: (value: boolean) => void;
}

const DEFAULT_VALUE: VaultPageContextInterface = {
  setShowCreateCredentialModal: () => {},
};

export const VaultPageContext = createContext<VaultPageContextInterface>(DEFAULT_VALUE);
